$(document).ready(function () {

    $(document).on('click', '.select-backup', function () {
        $('#btn-restore, #btn-delete').attr('disabled', !this.checked);
        $(this).closest('tr').toggleClass('bg-warning', this.checked);
    });

    $('#backup-form').submit(function (e) {
        e.preventDefault();
        $('#type').val(e.originalEvent.submitter.dataset.action);
        this.submit();
    });

});
